import React from "react"
import styled from "styled-components"
import LoadingOverlay from "../../components/LoadingOverlay"
import { useLoadingState } from "../../globalStates/LoadingState"
import MainContent from "../mainContent"
import NotificationsContainer from "../Notifications"
import Sidebar from "../sidebar"

const MainLayoutWrapper = styled.div`
    font-family: Roboto;
    font-style: normal;
    font-size: 16px;
    line-height: 19px;
    color: #202428;
`

const MainLayout: React.FC<{}> = (props) => {
    const loadingState = useLoadingState()
    return (
        <MainLayoutWrapper>
            <LoadingOverlay active={loadingState.isActive()}>
                <Sidebar />
                <MainContent />
                <NotificationsContainer />
            </LoadingOverlay>
        </MainLayoutWrapper>
    )
}

export default MainLayout
